import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

export interface NotificationSettings {
  notificationsOn: boolean
  notificationsChangeOn: boolean
  overrideDisabled: boolean
  overrideDisabledReason: string
  overrideUsed: boolean
  overrideAmount: number
}

// GET /family/{family_account_id}/notification_settings_data
export const notificationSettings = async (familyAccountId: number) => {
  const response = await new Request().get(
    '/ajax/family/' + familyAccountId + '/notification_settings'
  )
  return Util.Obj.keysToCamel(response.data.notification_settings) as NotificationSettings
}
